module.exports = __webpack_public_path__ + "static/bluunext-bold-webfont-ac4fcc19a03841577b9d8688bc08482d.svg";